import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceAnalystProfile from "@/pages/IntelligenceAnalystProfile";

export const Route = createFileRoute("/_app/intelligence/analysts/$id")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceAnalystProfile /></PageGate>
  ),
});
